import type { AdminTabEventType, AdminTabScene } from '../interfaces';

const ADMIN_TAB_EVENT_PREFIX = 'fxEvt:adminTab';

export const getAdminTabEventName = (scene: AdminTabScene, eventType: AdminTabEventType) =>
    `${ADMIN_TAB_EVENT_PREFIX}:${scene}:${eventType}`;
